import {
  FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
  UPDATE_APPROVED_QTY_SUCCESS,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        ProductreturnsDetails: action.payload.rows,
        ProductreturnsCount: action.payload.count,
      };
    case FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        ProductReturnDtls: action.payload.rows,
        ItemCount: action.payload.count,
      };
    case UPDATE_APPROVED_QTY_SUCCESS: {
      const { id, approvedQntty } = action.payload;

      return {
        ...state,
        ProductReturnDtls: state.ProductReturnDtls?.map((item) =>
          item.id === id ? { ...item, approvedQntty } : item
        ),
      };
    }

    default:
      return {
        ...state,
      };
  }
}
